var map, popups = [], Popup;
window.initMap = function() {
	definePopupClass();
	var mapNode = document.getElementById('map');

	// initialize map
	map = new google.maps.Map(mapNode, {
		zoom: 10,
		center: new google.maps.LatLng(45.070312, 7.686856), // turin coordinates
		mapTypeControlOptions: {
            mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map']
        }
	});

	// set style map
	var styledMapType = new google.maps.StyledMapType(
		[
			{
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#f5f5f5"
				}
			  ]
			},
			{
			  "elementType": "labels.icon",
			  "stylers": [
				{
				  "visibility": "off"
				}
			  ]
			},
			{
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#616161"
				}
			  ]
			},
			{
			  "elementType": "labels.text.stroke",
			  "stylers": [
				{
				  "color": "#f5f5f5"
				}
			  ]
			},
			{
			  "featureType": "administrative.land_parcel",
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#bdbdbd"
				}
			  ]
			},
			{
			  "featureType": "poi",
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#eeeeee"
				}
			  ]
			},
			{
			  "featureType": "poi",
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#757575"
				}
			  ]
			},
			{
			  "featureType": "poi.park",
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#e5e5e5"
				}
			  ]
			},
			{
			  "featureType": "poi.park",
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#9e9e9e"
				}
			  ]
			},
			{
			  "featureType": "road",
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#ffffff"
				}
			  ]
			},
			{
			  "featureType": "road.arterial",
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#757575"
				}
			  ]
			},
			{
			  "featureType": "road.highway",
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#dadada"
				}
			  ]
			},
			{
			  "featureType": "road.highway",
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#616161"
				}
			  ]
			},
			{
			  "featureType": "road.local",
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#9e9e9e"
				}
			  ]
			},
			{
			  "featureType": "transit.line",
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#e5e5e5"
				}
			  ]
			},
			{
			  "featureType": "transit.station",
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#eeeeee"
				}
			  ]
			},
			{
			  "featureType": "water",
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#c9c9c9"
				}
			  ]
			},
			{
			  "featureType": "water",
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#9e9e9e"
				}
			  ]
			}
		  ],
		{name: 'Silver'}
	);
	map.mapTypes.set('styled_map', styledMapType);
  	map.setMapTypeId('styled_map');

	// position markers
	var locationsJson = JSON.parse(mapNode.dataset.locations);

	var marker, i;
	var bounds = new google.maps.LatLngBounds();

	locationsJson.forEach(function (location,index) {
		// create icon marker
		marker = new google.maps.Marker({
			position: new google.maps.LatLng(location['latitude'], location['longitude']),
			icon: mapNode.dataset.icon,
			map: map
		});

		var popup = new Popup(
	  		new google.maps.LatLng(location['latitude'], location['longitude']),
			  document.getElementById('info-window-' + index)
		);

		popups.push(popup);

		marker.addListener('click', function(element) {
			var openPopup = document.getElementById('info-window-' + index);
			if (openPopup.style.display == 'block') {
				openPopup.style.display = 'none';
			} else {
				openPopup.style.display = 'block';
			}
		});

		// extend map
		bounds.extend(marker.getPosition());
	});
	// add popup
	popups.forEach(function(Element, index) {
		Element.setMap(map);
	});

	// set zoom and center map
	map.fitBounds(bounds);
}

/** Defines the Popup class. */
function definePopupClass() {

	/**
	 * A customized popup on the map.
	 * @param {!google.maps.LatLng} position
	 * @param {!Element} content
	 * @constructor
	 * @extends {google.maps.OverlayView}
	 */
	Popup = function(position, content) {
		this.position = position;

		content.classList.add('popup-bubble-content');

		var pixelOffset = document.createElement('div');
		pixelOffset.classList.add('popup-bubble-anchor');
		pixelOffset.appendChild(content);

		this.anchor = document.createElement('div');
		this.anchor.classList.add('popup-tip-anchor');
		this.anchor.appendChild(pixelOffset);

		// Optionally stop clicks, etc., from bubbling up to the map.
		this.stopEventPropagation();
	};
	// NOTE: google.maps.OverlayView is only defined once the Maps API has
	// loaded. That is why Popup is defined inside initMap().
	Popup.prototype = Object.create(google.maps.OverlayView.prototype);

	/** Called when the popup is added to the map. */
	Popup.prototype.onAdd = function() {
		this.getPanes().floatPane.appendChild(this.anchor);
	};

	/** Called when the popup is removed from the map. */
	Popup.prototype.onRemove = function() {
		if (this.anchor.parentElement) {
			this.anchor.parentElement.removeChild(this.anchor);
		}
	};

	/** Called when the popup needs to draw itself. */
	Popup.prototype.draw = function() {
		var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
		// Hide the popup when it is far out of view.
		var display =
			Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
			'block' :
			'none';

		if (display === 'block') {
			this.anchor.style.left = divPosition.x + 'px';
			this.anchor.style.top = divPosition.y + 'px';
		}
		if (this.anchor.style.display !== display) {
			this.anchor.style.display = display;
		}
	};

	/** Stops clicks/drags from bubbling up to the map. */
	Popup.prototype.stopEventPropagation = function() {
		var anchor = this.anchor;
		anchor.style.cursor = 'auto';

		['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart', 'pointerdown']
		.forEach(function(event) {
			anchor.addEventListener(event, function(e) {
			e.stopPropagation();
			});
		});
	};
}


// WEBPACK FOOTER //
// ./src/components/molecules/map/map.js